export const validateObject = (obj = {}) => {
  const filteredObj = Object.entries(obj).filter(([key, value]) => {
    return !!value
  })
  const searchObject = Object.fromEntries(filteredObj)
  return searchObject
}